module.exports = __webpack_public_path__ + "img/viz_beers.0a86424f.png";